'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _tslib = require('../../_virtual/_tslib.js');
var jsxRuntime = require('react/jsx-runtime');
var React = require('react');

var SvgArrowUp = function (props, ref) { return (jsxRuntime.jsx("svg", _tslib.__assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref }, props, { children: jsxRuntime.jsx("path", { d: "M11.806.965c-.074.022-.2.082-.28.134-.08.051-1.778 1.729-3.772 3.727-2.571 2.577-3.652 3.686-3.715 3.811-.176.353-.087.718.26 1.064.347.347.711.436 1.064.26.124-.063.993-.903 2.907-2.814L11 4.421v8.4c0 5.503.014 8.449.041 8.544.107.385.396.597.855.626.485.031.803-.109.984-.433l.1-.178.01-8.479.011-8.479 2.729 2.725c1.914 1.911 2.783 2.751 2.907 2.814.353.176.717.087 1.064-.26.347-.346.436-.711.26-1.064-.121-.242-7.337-7.471-7.576-7.589-.212-.105-.41-.134-.579-.083", fillRule: "evenodd", fill: "currentColor" }) }))); };
var ForwardRef = React.forwardRef(SvgArrowUp);

exports["default"] = ForwardRef;
//# sourceMappingURL=ArrowUp.js.map
